import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { query, collection, where, getDocs } from "firebase/firestore";
import { db, auth } from "../Firebase/firebase";

const useGetUser = () => {
  const [userData, setUserData] = useState({});
  const [userId, setUserId] = useState("");

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      const q = query(
        collection(db, "users"),
        where("email", "==", user?.email)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setUserId(doc.id);
        setUserData(doc.data());
        // console.log(doc.data());
      });
    });
  }, []);

  return { userData, userId };
};

export default useGetUser;